<script>
import StageNode from './Stage.vue';
import ButtonNext from 'next/button/Button.vue';

export default {
  components: {
    StageNode,
    ButtonNext,
  },
  props: {
    workflow: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['addStage', 'deleteStage', 'editStage'],
  computed: {
    stages() {
      return this.$store.getters['wgptBotWorkflowStages/getStages'](
        this.workflow.id
      );
    },
  },
  watch: {
    bot() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      const botId = this.$route.params.botId;
      const workflowId = this.workflow.id;
      this.$store.dispatch('wgptBotWorkflowStages/get', { botId, workflowId });
    },
  },
};
</script>

<template>
  <div class="grid grid-cols-2">
    <div class="col-start-2 stage-nodes pointer-events-auto">
      <div v-for="stage in stages" :key="stage.id" class="stage-node">
        <div class="stage-node-content py-3">
          <StageNode
            :stage="stage"
            @edit="$emit('editStage', stage)"
            @delete="$emit('deleteStage', stage)"
          />
        </div>
      </div>

      <div class="stage-node">
        <div class="stage-node-content py-3">
          <ButtonNext
            class="my-0"
            icon="i-lucide-circle-plus"
            :label="
              $t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.BUTTON_TEXT.CREATE_STAGE')
            "
            @click="$emit('addStage')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.stage-nodes::before {
  @apply h-8 w-8 border-l border-dashed border-n-slate-10;
  content: '';
}

.stage-node {
  @apply relative;
  &::before {
    @apply absolute w-8;
    @apply border-l border-dashed border-n-slate-10;
    @apply border-b border-dashed border-n-slate-10;
    content: '';
    height: 50%;
  }
  &:not(:last-child)::after {
    @apply absolute w-8 top-1/2;
    @apply border-l border-dashed border-n-slate-10;
    content: '';
    height: 50%;
  }
  .stage-node-content {
    @apply ml-9;
  }
}

[dir='rtl'] {
  .stage-nodes::before {
    @apply border-l-0;
    @apply border-r border-dashed border-n-slate-10;
  }

  .stage-node {
    &::before {
      @apply border-l-0;
      @apply border-r border-dashed border-n-slate-10;
    }
    &:not(:last-child)::after {
      @apply border-l-0;
      @apply border-r border-dashed border-n-slate-10;
    }
    .stage-node-content {
      @apply ml-0 mr-9;
    }
  }
}
</style>
